













import {
  Component,
  Vue,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { namespace } from "vuex-class";
import Loader from "@/components/Loader.vue";
import { formatService } from "../../services/format.service";
import { IOverallPerformanceSummary } from "../../models/interfaces/performance/overall-performance-summary.model.interface";
import { IProperty } from "../../models/interfaces/property/property.model.interface";

const PropertyPerformanceModule = namespace("propertyPerformanceModule");
const ZoneEnquiryModule = namespace("zoneEnquiryModule");
const UserSelectionModule = namespace("userSelectionModule");
const PublisherModule = namespace("publisherModule");

@Component({
  components: {
    Loader
  }
})
export default class PropertyPerformanceOverviewTable extends Vue {
  @ZoneEnquiryModule.Getter public zonesOverview;
  @PropertyPerformanceModule.Getter public propertyZoneQualityArrivalPerformance;
  @UserSelectionModule.Getter public selectedDates;
  @PublisherModule.Getter public selectedProperty: IProperty | null;

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: false })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  @Prop({ default: false })
  public revenueAccess!: boolean;

  private loading: boolean = true;

  public get getSelectedProperty(): IProperty | null {
    return this.selectedProperty;
  }

  public get getDates(): Date {
    return this.selectedDates;
  }

  public get pageImpressions(): number {
    const leadGenTotal = this.zonesOverview.map((x) => x.performance.loads).reduce((a, b) => a + b, 0);
    const qualityArrivalTotal = this.propertyZoneQualityArrivalPerformance.map((x) => x.loads).reduce((a, b) => a + b, 0);
    return leadGenTotal + qualityArrivalTotal;
  }

  public get contentImpressions(): number {
    const leadGenTotal = this.zonesOverview.map((x) => x.performance.impressions).reduce((a, b) => a + b, 0);
    const qualityArrivalTotal = this.propertyZoneQualityArrivalPerformance.map((x) => x.impressions).reduce((a, b) => a + b, 0);
    return leadGenTotal + qualityArrivalTotal;
  }

  public get interactions(): number {
    const leadGenTotal = this.zonesOverview.map((x) => x.performance.keyPresses).reduce((a, b) => a + b, 0);
    const qualityArrivalTotal = this.propertyZoneQualityArrivalPerformance.map((x) => x.keyPresses).reduce((a, b) => a + b, 0);
    return leadGenTotal + qualityArrivalTotal;
  }

  public get clickThroughs(): number {
    const leadGenTotal = this.zonesOverview.map((x) => x.performance.clicks).reduce((a, b) => a + b, 0);
    const qualityArrivalTotal = this.propertyZoneQualityArrivalPerformance.map((x) => x.clicks).reduce((a, b) => a + b, 0);
    return leadGenTotal + qualityArrivalTotal;
  }

  public get conversions(): number {
    const leadGenTotal = this.zonesOverview.map((x) => x.enquiry.enquiries).reduce((a, b) => a + b, 0);
    const qualityArrivalTotal = this.propertyZoneQualityArrivalPerformance.map((x) => x.clicks).reduce((a, b) => a + b, 0);
    return leadGenTotal + qualityArrivalTotal;
  }

  public get revenue(): number {
    return this.zonesOverview.map((x) => x.enquiry.revenue).reduce((a, b) => a + b, 0);
  }

  public items: IOverallPerformanceSummary[] = [];

  @Provide()
  public columns = [
    // {
    //   key: "loads",
    //   label: "Page Impressions",
    //   formatter: (value, key, item) => {
    //     return formatService.formatNumber(value);
    //   }
    // },
    {
      key: "impressions",
      label: "Content Impressions",
      formatter: (value, key, item) => {
        return formatService.formatNumber(value);
      }
    },
    {
      key: "keyPresses",
      label: "Interactions",
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          value,
          item.impressions
        );
      }
    },
    {
      key: "clicks",
      label: "Click Throughs",
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          value,
          item.impressions
        );
      }
    },
    {
      key: "conversions",
      label: "Conversions (CPL & CPC)",
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          value,
          item.clicks
        );
      },
      class: this.revenueAccess ? "" : "d-none"
    },
    {
      key: "revenue",
      label: "Revenue (CPL)",
      formatter: (value, key, item) => {
        return formatService.formatCurrency(value);
      },
      class: this.revenueAccess ? "" : "d-none"
    }
  ];

  public setOverviewItems() {
    this.loading = true;

    this.items = [
      {
        loads: this.pageImpressions,
        impressions: this.contentImpressions,
        keyPresses: this.interactions,
        clicks: this.clickThroughs,
        conversions: this.conversions,
        revenue: this.revenue
      }
    ];

    this.loading = false;
  }

  @Watch('propertyZonePerformance', {deep: true})
  @Watch('zonesOverview', {deep: true})
  @Watch("getSelectedProperty")
  @Watch("selectedDates")
  public onZonePerformanceChanged() {
    if (!this.propertyZoneQualityArrivalPerformance || !this.zonesOverview) {
      return;
    }

    this.setOverviewItems();
  }
}
